import React from 'react';
import { SlateEditor } from '@plone/volto-slate/editor'; // Usa SlateEditor

const RichTextEditor = ({ value, onChange }) => {
  const handleChange = (newValue) => {
    onChange({ data: newValue }); // Salva nel formato Slate
  };

  return (
    <SlateEditor
      value={value?.data || [{ type: 'p', children: [{ text: '' }] }]}
      onChange={handleChange}
      readOnly={false}
    />
  );
};

export default RichTextEditor;